import { UserCheckIcon } from 'lucide-react';

interface MarkedFilterProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export default function MarkedFilter({ value, onChange }: MarkedFilterProps) {
  return (
    <div>
      <div className="flex items-center space-x-2 mb-4">
        <UserCheckIcon className="h-5 w-5 text-primary-500" />
        <span className="font-medium text-gray-700">Invited SNAPs:</span>
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => onChange(false)}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            !value
              ? 'bg-gray-900 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          All
        </button>
        <button
          onClick={() => onChange(true)}
          className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            value
              ? 'bg-primary-600 text-white'
              : 'bg-primary-100 text-primary-800 hover:bg-primary-200'
          }`}
        >
          <UserCheckIcon className="h-4 w-4 mr-2" />
          Invite Only
        </button>
      </div>
    </div>
  );
}